export default __webpack_public_path__ + "static/media/header-3.d9ed5371.jpg";